import Roles from '@/auth/roles';
import PlayerForm from './team-manager-form';
import PlayerList from './team-manager-list';
import PlayerHistoryFull from './team-manager-history/team-manager-history-full/team-manager-history-full';
import PlayerHistorySingle from './team-manager-history/team-manager-history-single/team-manager-history-single';
import PlayerShow from './team-manager-show';

const roles = Roles.values;

export default [
  {
    name: 'teamManagerList',
    path: 'KteamManager',
    component: PlayerList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamManagerViewer.id,
        roles.teamManagerEditor.id
      ]
    }
  },
  {
    name: 'teamManagerNew',
    path: 'KteamManager/new',
    component: PlayerForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamManagerEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'teamManagerEdit',
    path: 'KteamManager/:id/edit',
    component: PlayerForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamManagerEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'teamManagerHistorySingle',
    path: 'KteamManager/:id/history',
    component: PlayerHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'teamManagerHistoryFull',
    path: 'KteamManager/history',
    component: PlayerHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'teamManagerShow',
    path: 'KteamManager/:id',
    component: PlayerShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamManagerViewer.id,
        roles.teamManagerEditor.id,
        roles.clubManager.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/team-manager/team-manager-routes.js